import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ProductService } from '../../../product.service';
import { PRODUCT_TTL_ES } from '../../../product.interface';
import { UpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.template';
import { IUpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.interface';

@Component({
  selector: 'pg-product-update',
  templateUrl: './product-update.component.html'
})
export class ProductUpdateComponent
  extends UpdateTemplate
  implements IUpdateTemplate
{
  readyToUpdate = false;
  changeForm = false;
  select = {
    item: {
      type: 'single',
      openDialog: false,
      id: undefined
    },
    laboratory: {
      type: 'single',
      openDialog: false,
      id: undefined
    },
    unitMeasure: {
      type: 'single',
      openDialog: false,
      id: undefined
    }
  };

  constructor(private fb: FormBuilder, private productService: ProductService) {
    super(PRODUCT_TTL_ES, productService);
  }

  ngOnInit() {
    const item = this.row;
    this.fg = this.fb.group({
      item: [
        { value: item.itemCode + ' - ' + item.itemName, disabled: true },
        [Validators.required]
      ],
      laboratory: [
        { value: item.laboratoryDescription, disabled: true },
        [Validators.required]
      ],
      unitMeasure: [
        { value: item.unitMeasureDescription, disabled: true },
        [Validators.required]
      ]
    });
    this.select.item.id = item.itemId;
    this.select.laboratory.id = item.laboratoryId;
    this.select.unitMeasure.id = item.unitMeasureId;
  }

  onSubmit() {
    if (this.readyToUpdate) {
      this.updateItem$(this.parseData());
    }
  }

  parseData() {
    return {
      itemId: this.select.item.id,
      unitMeasureId: this.select.unitMeasure.id,
      laboratoryId: this.select.laboratory.id
    };
  }

  onSelectedItem(row) {
    if (row) {
      this.select.item.id = row.id;
      this.fg.get('item').setValue(row.code + '-' + row.name);
      this.setReadyToCreate();
    }
    this.select.item.openDialog = false;
  }

  onSelectedLaboratory(row) {
    if (row) {
      this.select.laboratory.id = row.id;
      this.fg.get('laboratory').setValue(row.description);
      this.setReadyToCreate();
    }
    this.select.laboratory.openDialog = false;
  }

  onSelectedUnitMeasure(row) {
    if (row) {
      this.select.unitMeasure.id = row.id;
      this.fg.get('unitMeasure').setValue(row.description);
      this.setReadyToCreate();
    }
    this.select.unitMeasure.openDialog = false;
  }

  setReadyToCreate() {
    this.readyToUpdate =
      this.select.laboratory.id &&
      this.select.unitMeasure.id &&
      this.select.item.id;
  }
}
